import { find, isEmpty, isEqual, lowerCase, sortBy } from 'lodash';

export const checkBackgroundProgress = (arr) => {
    let result = true;

    result = find(arr, { status: 'Inprogress' })?.status;

    return result;
};

export const checkIsShowSaveButton = (prev, current) => {
    if (isEmpty(prev)) return false;
    const object1 = {
        ...prev,
        template_upload: null,
        system_type: { id: prev?.system_type?.id },
        tag: { id: prev?.tag?.value },
        customer_id_konsi: prev?.customer_id_konsi || null,
        transfer_status: lowerCase(prev?.transfer_status?.name),
        trx_code: prev?.trx_code?.length > 0 ? sortBy(prev?.trx_code, (code) => code.id) : null,
    };
    const object2 = {
        ...current,
        template_upload: null,
        system_type: { id: current?.system_type?.id },
        tag: { id: current?.tag?.value },
        customer_id_konsi: current?.customer_id_konsi || null,
        transfer_status: lowerCase(current?.transfer_status?.name),
        trx_code: current?.trx_code?.length > 0 ? sortBy(current?.trx_code, (code) => code.id) : null,
    };

    return !isEqual(object1, object2);
};
